
import { Options, Vue } from 'vue-class-component';
import mapConfig from "@/config/map";
import RegionService from "@/services/RegionService";
import NavigationService from '@/services/NavigationService';
import {OptionalDistanceRegion, OptionalDistanceRegionMinimal, RegionManager} from "@/data/region";
import RegionCourses from "@/components/RegionCourses.vue";
import RegionCoursesModal from "@/components/modals/RegionCoursesModal.vue";


@Options({
    props: {
        regionId: {
            type: Number,
            required: false,
        },
        region: {
            type: Object,
            required: false,
            default: null,
        },
        showCoursesButton: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    components: {
        RegionCourses,
        RegionCoursesModal,
    },
})
export default class RegionListEntry extends Vue {
    regionId: number|null = null
    region: OptionalDistanceRegionMinimal|null = null
    regionLocal: OptionalDistanceRegionMinimal|null = null
    showCoursesButton = false

    loading = false

    modalShown = false
    openModal() {
        this.modalShown = true;
    }
    closeModal() {
        this.modalShown = false;
    }

    get parksString() : string|null {
        // console.log(JSON.stringify(this.regionLocal, null, 2));

        if( typeof this.regionLocal === 'undefined' || typeof this.regionLocal?.locations === 'undefined' || this.regionLocal?.locations?.length < 2 ) {
            return null;
        }
        return this.regionLocal?.locations.map(location => location.name).join(', ');
    }

    loadRegion() {
        this.loading = true;
        return RegionService.getRegion(this.regionId as number).then(result => {
            this.regionLocal = result.data?.data;
        }).finally(() => this.loading = false);
    }

    get registerUrl() {
        return this.regionLocal ? NavigationService.buildRouteUrl('register', { region: this.regionLocal.id }) : '#';
    }

    mounted() {
        this.$watch('region', (newRegion: OptionalDistanceRegion|null) => {
            this.regionLocal = JSON.parse(JSON.stringify(newRegion));
        }, { immediate: true });

        this.$watch('regionId', (newRegionId: number|null) => {
            if( newRegionId ) {
                this.$nextTick(this.loadRegion);
            }
        }, { immediate: true });
    }
}
